import Component from '@glimmer/component'
import { t } from 'ember-intl'
import RouteTemplate from 'ember-route-template'
import RadioButtonGroup from 'teacher-ui-client/components/base/radio-button-group.gts'
import PageHeader from 'teacher-ui-client/components/page-header/index.gts'
import { LongWritesCatalogueList } from 'teacher-ui-client/components/writing-legends/long-writes-catalogue-list.gts'
import { tracked } from '@glimmer/tracking'
import InputText from 'teacher-ui-client/components/base/input-text.gts'
import pick from 'teacher-ui-client/helpers/pick'
import { on } from '@ember/modifier'
import themeKey from 'teacher-ui-client/helpers/theme-key'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'
import { service } from '@ember/service'

export interface LongWritesFilterButton {
  value: '3,4' | '5,6,7+'
  text: string
}

export class LongWritesPage extends Component {
  @service subscriptionType!: SubscriptionTypeService

  @tracked
  currentlyFilteredGradePosition: LongWritesFilterButton['value'] = '3,4'

  @tracked
  textFilter: Nullable<string> = null

  get gradePositionFilterButtons(): LongWritesFilterButton[] {
    return [
      { value: '3,4', text: 'Years 3, 4' },
      { value: '5,6,7+', text: 'Years 5, 6, 7 +' },
    ]
  }

  filterByGradePosition = (grade: LongWritesFilterButton['value']) => {
    this.currentlyFilteredGradePosition = grade
  }

  updateTextFilter = (text: string) => {
    this.textFilter = text
  }
  <template>
    <div class="grow">
      <PageHeader>
        <:title>
          <h1>
            {{t "pages.longWrites.title"}}
          </h1>
        </:title>
      </PageHeader>
      <div class="flex flex-wrap items-center justify-center gap-4">
        <RadioButtonGroup
          data-test-grade-position-filter
          class="flex"
          @name="grade-select"
          @buttons={{this.gradePositionFilterButtons}}
          @value={{this.currentlyFilteredGradePosition}}
          @onSelect={{this.filterByGradePosition}}
        />
        <InputText
          data-test-printables-search
          type="search"
          role="searchbox"
          name="search-filter"
          class="w-72"
          value={{this.textFilter}}
          @themeKey={{themeKey this.subscriptionType.current}}
          placeholder={{t "pages.longWrites.filters.searchPlaceholder"}}
          aria-label={{t "pages.longWrites.filters.searchPlaceholder"}}
          @icon="search"
          @iconEnd={{true}}
          {{on "input" (pick "target.value" this.updateTextFilter)}}
        />
      </div>
      <div class="mx-auto mt-10 w-4/5">
        <LongWritesCatalogueList
          @gradePositionFilter={{this.currentlyFilteredGradePosition}}
          @textFilter={{this.textFilter}}
        />
      </div>
    </div>
  </template>
}

export default RouteTemplate(LongWritesPage)
